import { Row, Col, Button, Image } from 'react-bootstrap';

function Kachel({icon, children, bgColor}) {
    return (
        <Row className='kachel py-3'>
            <Col>
                <Image className={"d-flex align-self-center rounded-circle bg-" + bgColor} src={icon} height="100px" width="100px"/>
                <br/>
                <ul>
                    {children}
                </ul>
            </Col>
        </Row>
   );
}


export default Kachel;